// extracted by mini-css-extract-plugin
export default {"container":"navigation_container__osIB4","return-link":"navigation_return-link__h7Zx2"};